<nz-spin nzTip="Loading..." [nzSpinning]="loadingVisible">
</nz-spin>
